import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import { useSettings } from "../../../context/SettingsContext";
import getImageUrl from "../../../utils/getImageUrl";

const NavHader = () => {
  const { getSetting } = useSettings();
  const [toggle, setToggle] = useState(false);
  const { openMenuToggle } = useContext(ThemeContext);

  const logoPath = getSetting("site_logo")?.path;
  const logoUrl = getImageUrl(logoPath);

  return (
    <div className="nav-header d-flex align-items-center justify-content-between px-3 py-2 position-fixed">
      {/* Logo */}
      <Link to="/dashboard" className="navbar-brand m-0 p-0">
        <img
          src={logoUrl}
          alt="site logo"
          className="img-fluid"
          style={{
            maxHeight: "50px",
            maxWidth: "100%",
            objectFit: "contain",
          }}
        />
      </Link>

      {/* Toggle button */}
      <button
        type="button"
        className={`nav-control btn p-0 border-0 bg-transparent ${
          toggle ? "active" : ""
        }`}
        onClick={() => {
          setToggle(!toggle);
          openMenuToggle();
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </button>
    </div>
  );
};

export default NavHader;
